import { mapState } from 'pinia';

export default {
  computed: {
    ...mapState(useMainStore, {
      configuration: 'configuration',
    }),
  },
  methods: {
    replacedTextWithDynamicFields(sourceText) {
      if (!sourceText) {
        return '';
      }

      return sourceText.replace(new RegExp('{{([^{}]*)}}', 'g'), (_unused, varName) => {
        if (!varName) {
          return '';
        }

        return this.configuration[varName.trim()] || '';
      });
    },
  },
};
